var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 76"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1137"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2,
    "data-name": "Ellipse 267"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 37,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.677 24.86a15.705 15.705 0 0 1 1.679-1.287 12.078 12.078 0 0 1 1.976-1.062 12.3 12.3 0 0 1 2.3-.711 13.13 13.13 0 0 1 2.688-.26 11.2 11.2 0 0 1 3.58.542 8.046 8.046 0 0 1 2.767 1.547 6.9 6.9 0 0 1 1.784 2.428 7.758 7.758 0 0 1 .632 3.185 8.044 8.044 0 0 1-.5 2.97 8.178 8.178 0 0 1-1.253 2.179 9.962 9.962 0 0 1-1.637 1.6q-.881.678-1.671 1.276a13.209 13.209 0 0 0-1.366 1.174 2.319 2.319 0 0 0-.689 1.3l-.519 3.3h-3.812l-.384-3.681a1 1 0 0 1-.023-.192v-.192a3.008 3.008 0 0 1 .5-1.728 7.048 7.048 0 0 1 1.239-1.378q.745-.644 1.6-1.253a14.385 14.385 0 0 0 1.609-1.321 6.65 6.65 0 0 0 1.24-1.615 4.338 4.338 0 0 0 .5-2.123 3.362 3.362 0 0 0-.3-1.457 3.294 3.294 0 0 0-.847-1.107 3.8 3.8 0 0 0-1.3-.711 5.219 5.219 0 0 0-1.644-.247 7.3 7.3 0 0 0-2.179.282 8.036 8.036 0 0 0-1.513.632q-.621.35-1.05.632a1.444 1.444 0 0 1-.768.282 1.232 1.232 0 0 1-1.175-.678zm4.265 26.628a3.473 3.473 0 0 1 .26-1.333 3.184 3.184 0 0 1 .723-1.084 3.557 3.557 0 0 1 1.1-.723 3.4 3.4 0 0 1 1.352-.27 3.348 3.348 0 0 1 1.333.271 3.322 3.322 0 0 1 1.807 1.807 3.439 3.439 0 0 1 0 2.676 3.452 3.452 0 0 1-.723 1.073 3.27 3.27 0 0 1-1.084.711 3.473 3.473 0 0 1-1.333.26 3.532 3.532 0 0 1-1.355-.26 3.4 3.4 0 0 1-1.1-.711 3.211 3.211 0 0 1-.721-1.069 3.448 3.448 0 0 1-.259-1.348z",
    "data-name": "Path 371"
  }))));
};
export default SvgQuestionMark;